<template>
    <div class="slider-container position-relative">
        <div class="member-slider">
            <member-slide
                v-for="(slide, index) in slides"
                :key="index"
                :slide="slide"
                :button-text="translations.sliderButton"
            />
        </div>
    </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import memberSlide from '@/components/members/member-slide';
import translationMixin from '@/mixins/translations';

export default {
    components: {
        memberSlide
    },
    mixins: [translationMixin],
    props: {
        slides: {
            type: Array,
            default: () => []
        }
    },
    mounted() {
        this.slider = tns({
            container: '.member-slider',
            items: 1,
            slideBy: 'page',
            controls: false,
            autoplay: true,
            speed: 1000,
            autoplayTimeout: 8000,
            autoplayButtonOutput: false,
            autoplayHoverPause: true
        });
    }
};
</script>

<style lang="scss">
@import 'src/scss/base/custom';
.slider-container {
    width: 100%;
    background-color: $brand-white;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}

.slider-item {
    background-size: cover;
    background-repeat: no-repeat;
    height: 500px;
    margin: 0;
}

.slider-container .card {
    margin: 0;
    box-shadow: none;

    &:hover {
        box-shadow: none;
    }
}

.slider-container .card__text {
    position: absolute;
    bottom: 80px;
    color: $brand-white;

    h2,
    span {
        text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
    }
}

.slider-container .card__text span {
    font-size: 1.25rem;
}

.slider-container .tns-nav {
    position: absolute;
    bottom: 75px;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
}

.slider-container .tns-nav button {
    width: 10px;
    height: 10px;
    margin: 0 10px 0 0;
    background-color: $brand-gray-dark;
    display: inline-block;
    border-radius: 5px;
    padding: 0;
    border: 0;
}

.slider-container .tns-nav .tns-nav-active,
.slider-container .tns-nav button:hover {
    background-color: $brand-blue;
}

.slider-container .card__bottom {
    padding-top: 0;
}

.slider-container .card__bottom__button {
    color: $brand-blue;
    background-color: $brand-white;
}
</style>
